import { SidePanel } from '@/components/SidePanel/SidePanel';
import IntlMessages from '@/components/utility/intlMessages';
import { ForgotPasswordForm } from './components/forgot-password-form';

export default function ForgotPassword() {
  return (
    <div className="grid flex-1 grid-cols-1 md:grid-cols-[35%_1fr]">
      <div className="flex flex-col gap-y-5 m-6 md:m-10 py-10">
        <h3 className="text-xl">
          <IntlMessages id="page.forgotPasswordTitle" />
        </h3>
        <p>
          <IntlMessages id="page.forgotPasswordParagraph" />
        </p>
        <ForgotPasswordForm />
      </div>
      <div className="md:shadow-[inset_rgba(0,0,0,0.05)_0px_4px_10px_0px] overflow-y-auto h-full">
        <SidePanel />
      </div>
    </div>
  );
}
